import messages from '../../../../locale/messages';

const validate = values => {
    const errors = {};
    if (!values.baseFare || values.baseFare <= 0) {
        errors.baseFare = messages.required;
    } else if (values.baseFare.toString().trim() == "") {
        errors.baseFare = messages.required;
    } else if (isNaN(values.baseFare)) {
        errors.baseFare = messages.numericValue;
    }
    return errors;
}
export default validate